import { createAction, props } from "@ngrx/store";

export const resetPassword = createAction("[Auth] resetPassword", props<{ token: string, password: string }>());
export const complete = createAction("[Auth] resetPasswordComplete");
export const failure = createAction("[Auth] resetPasswordFailure", props<{ error: any }>());
export const clearState = createAction("[Auth] clearResetPasswordState");